function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M13.47 3.284a1.73 1.73 0 011.237 1.204C15 5.549 15 8.444 15 8.444s0 2.895-.293 3.957a1.727 1.727 0 01-1.237 1.203c-1.092.285-5.47.285-5.47.285s-4.378 0-5.47-.285a1.727 1.727 0 01-1.237-1.203C1 11.34 1 8.444 1 8.444s0-2.895.293-3.956A1.729 1.729 0 012.53 3.284C3.622 3 8 3 8 3s4.378 0 5.47.284zM6.6 6.676v3.537c0 .262.292.426.525.294l3.15-1.768a.336.336 0 000-.59l-3.15-1.767c-.233-.131-.525.032-.525.294z",
  clipRule: "evenodd"
});

function SvgYoutubeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgYoutubeinline;